import React, { useEffect, useState } from 'react';
import { Collapse } from 'react-collapse';
import Icon from './Icon';
import clsx from 'clsx';

interface CollapsibleAttributes {
  label?: string | JSX.Element;
  className?: string;
  labelClassName?: string;
  transitionDuration?: string;
  onStateChange?: Function;
  isOpen?: boolean;
  hideBorder?: boolean;
  children?: any;
}

const Collapsible = ({
  children,
  label,
  className = '',
  labelClassName = '',
  transitionDuration = '0.2s',
  onStateChange: externalStateChange,
  isOpen: externalIsOpen,
  hideBorder,
}: CollapsibleAttributes) => {
  const [isOpen, setIsOpen] = useState<boolean>(externalIsOpen ?? false);

  const onStateChange = (open: boolean) => {
    externalStateChange && externalStateChange(open);
    setIsOpen(open);
  };

  useEffect(() => {
    setIsOpen(externalIsOpen ?? false);
  }, [externalIsOpen]);

  return (
    <div
      className={`collapsible ${className ?? ''} ${
        hideBorder ? 'collapsible--no-border' : ''
      }`}
    >
      <label
        className={`flex items-center justify-between text-xl ${
          labelClassName ?? ''
        }`}
        onClick={() => onStateChange(!isOpen)}
      >
        {label}
        <Icon
          className={clsx(isOpen ? 'rotate-180' : 'rotate-0', 'h-5 w-5')}
          style={{ transitionDuration: transitionDuration }}
          name="caret-down"
        />
      </label>
      <div className="collapsible__content">
        <Collapse isOpened={isOpen}>{children}</Collapse>
      </div>
    </div>
  );
};

export default Collapsible;
